<app-larged-tuile
  icon="fa-kit fa-picto-filtration"
  [title]="'dashboard.filtration' | translate"
  [buttons]="buttons"
  [status]="
    buttons[this.actionStack!.getValue('fsSCommandePompe')].title! | translate
  "
  [mode]="
    P0003600ProgrammeFiltrationAuto[
      this.actionStack!.getValue('fsCProgrammeFiltrationAuto')
    ].value
  "
  [statusMode]="
    this.actionStack!.getValue('fsSAlarme') === 1
      ? 'alarm'
      : buttons[this.actionStack!.getValue('fsSCommandePompe')].status!
  "
  [selectItem]="this.actionStack!.getValue('fsCModeFonctionnement')"
  (onPressSetting)="this.openProductModal()"
  (onChange)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.FiltrationStandard_Controle,
      'fsCModeFonctionnement',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-larged-tuile>
